import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

export const useForgotPassword = () => {
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const forgotPasswordMutation = useMutation({
        mutationFn: async ({ email }) => {
            const host = window.location.host.startsWith('localhost')
                ? 'teamsdev.tcap.dev'
                : window.location.host;

            const endpoint = `https://${host}/api/ui/forgotpassword`;

            const response = await fetch(endpoint, {
                headers: {
                    accept: 'application/json',
                    'content-type': 'application/json;charset=UTF-8',
                    'x-requestscope': '20',
                },
                method: 'POST',
                body: JSON.stringify({
                    username: email,
                    host: `${host}/ui/change-password?token=[TOKEN]`,
                }),
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(
                    data.message ||
                        'An error occurred, please try again later.',
                );
            }

            return response.text();
        },
        onSuccess: () => {
            setError(null);
            setSuccess(true);
            toast.success('Password reset link sent to your email!');
        },
        onError: (error) => {
            setSuccess(false);
            setError(error.message);
            toast.error(error.message);
        },
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await forgotPasswordMutation.mutateAsync(values);
        } catch (error) {
            // Error handled in onError callback
        } finally {
            setSubmitting(false);
        }
    };

    const resetMessages = () => {
        setError(null);
        setSuccess(false);
    };

    return {
        handleSubmit,
        isLoading: forgotPasswordMutation.isPending,
        error,
        success,
        resetMessages,
        mutation: forgotPasswordMutation,
    };
};
